const techColorClientNames: Record<string, string> = {
    Cyan: 'Cyan',
    'Cyan 2': 'Cyan 2',
    Magenta: 'Magenta',
    'Magenta 2': 'Magenta 2',
    Yellow: 'Yellow',
    'Yellow 2': 'Yellow 2',
    Black: 'Black',
    'Black 2': 'Black 2',
    'Black 3': 'Black 3',
    'Black txt': 'Black txt',
    CUT: 'Высечка',
    W1: 'Белила',
    W2: 'Белила 2',
    'Lak gloss': 'Глянец',
    'Lak mat.': 'Матовый',
    'Tisnenie Gold': 'Золото',
    'Tisnenie Silver': 'Серебро',
    'DMS Tisnenie': 'DMS Тиснение',
    'DMS Lak': 'DMS Лак',
    Reliz: 'Релиз',
    Primer: 'Праймер',
    Statik: 'Статик',
    Kongrev: 'Конгрев',
}

export function techColorPickerLabel(name: string): string {
    const display = techColorClientNames[name]
    if (!display || display === name) return name
    return `${name} / ${display}`
}
